import {
  createApp
} from 'vue';
import Axios from 'axios';
import Notifications from '@kyvg/vue3-notification';
import App from '@/App.vue';
import Router from '@/Router';
import 'remixicon/fonts/remixicon.css';
import ScrollAnimation from '@/Directives/ScrollAnimation'

const Application = createApp(App)
  .use(Router)
  .use(Notifications)
  .directive("scrollanimation", ScrollAnimation);

Application.config.globalProperties.$http = Axios;

const token = localStorage.getItem('token');
if (token) {
  this.$http.defaults.headers.common.Authorization = token;
}

Application.directive('clickoutside', {
  beforeMount(el, binding) {
    el.clickOutsideEvent = function (event) {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event, el);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Application.mount('#app');